import { render, staticRenderFns } from "./CommesaImpegno.vue?vue&type=template&id=2a3efbca&"
import script from "./CommesaImpegno.vue?vue&type=script&lang=js&"
export * from "./CommesaImpegno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports